import { Component, Renderer2, ViewEncapsulation, ElementRef, ViewChild, OnInit } from '@angular/core';
import { ApiService, CacheService, Picture } from 'angular-lib';
import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';
import { environment } from '../../../environments/environment';
import { LoaderService } from '../../services/loader.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../services/toast.service';
import { AlbumComponent } from './album.component';
import { User } from 'angular-lib';

@Component({
    selector: 'ez-album',
    template: require('./upload.component.html'),
    styles: [require('./upload.component.less')],
    encapsulation: ViewEncapsulation.None
})
export class UploadComponent implements OnInit {
    @ViewChild('inputFile') private inputFile: ElementRef;
    public uploading: boolean = false;
    public uploader: FileUploader;
    public error: any;
    public env = null;
    public user: User = null;

    public fbPictures: any[] = [];
    public pictures: Picture[] = [];
    public fbNSelected: number = 0;

    constructor(
        private apiService: ApiService,
        private router: Router,
        private loader: LoaderService,
        private translationService: TranslateService,
        private renderer: Renderer2,
        private toastService: ToastService,
    ) {
        this.env = environment;
        this.configUpload();
    }

    public ngOnInit() {
        this.loader.show();
        this.apiService.user().subscribe(result => {
            this.loader.hide();
            this.user = result;
            this.pictures = result.pictures;

            for (let i in this.pictures) {
                if (this.pictures[i].access === 'default') {
                    let first = this.pictures[i];
                    this.pictures.splice(parseInt(i), 1);
                    this.pictures.unshift(first);
                }
            }
        }, error => {
            this.loader.hide();
        });
    }

    private configUpload() {
        this.uploader = new FileUploader({
            url: this.apiService.uploadPictureUrl(true),
            autoUpload: true,
            isHTML5: true,
            headers: [
                {name: 'Accept', value: 'application/json'}
            ],
            maxFileSize: 12582912 // 12Mo max file size
        });

        this.uploader.authToken = 'Bearer ' + localStorage.getItem(environment.tokenName);
        this.uploader.onAfterAddingFile = (file: FileItem) => {
            file.withCredentials = false;
            file.alias = 'uploadPicture';
            file.onBeforeUpload = () => {
                this.loader.show();
                this.uploading = true;
            };
            file.onProgress = (p) => {
                console.log('onProgress', p);
            };
            file.onComplete = () => {
                this.uploading = false;
            };
            file.onSuccess = (response: string) => {
                let json = JSON.parse(response);
                if (json.result.id) {
                    let picture = new Picture(json.result);
                    this.album(picture.id);
                } else {
                    this.loader.hide();
                    this.toastService.show(json.result.error.message, ToastService.TYPE_ERROR, 3000);
                    // reset input file
                    this.inputFile.nativeElement.value = null;
                }
            };
        };
        this.uploader.onWhenAddingFileFailed = (item: FileLikeObject, filter: any, options: any) => {
            if (filter.name === 'fileSize') {
                this.translationService.get('common.errors.photo-too-large').subscribe(res => {
                    this.inputFile.nativeElement.value = null;
                    this.toastService.show(res, ToastService.TYPE_ERROR, 3000);
                })
            }
        }
    }

    public fbSignedIn(token: string) {
        this.loader.show();
        this.apiService.get('/f/facebook/profilePictures?accessToken=' + token)
            .subscribe(
                (data: Array<any>) => {
                    // pre select first 8
                    data.slice(0, 8).forEach(i => i.selected = true);
                    this.fbPictures = data;
                    this.fbNSelected = this.fbPictures.filter(a => a.selected).length;
                    this.loader.hide();
                },
                error => {
                    this.loader.hide();
                },
            );
    }

    public fbToggle(picture) {
        picture.selected = !picture.selected;
        this.fbNSelected = this.fbPictures.filter(a => a.selected).length;
    }

    public fbUpload() {
        let urls = this.fbPictures.filter(a => a.selected).map(p => p.source);
        if (urls.length === 0) {
            // No pictures to upload
            this.toastService.show('pictures.facebook-no-pictures', ToastService.TYPE_ERROR, 3000);
            return;
        }

        if (urls.length > (AlbumComponent.MAX_PICTURES - this.user.pictures.length)) {
            this.translationService.get('pictures.pictures-album-limit').subscribe(res => {
                this.toastService.show(res.replace('%number%', AlbumComponent.MAX_PICTURES), ToastService.TYPE_ERROR, 3000);
            });
            return;
        }

        this.loader.show();
        this.apiService
            .post('/ws/album/uploadUrls?extendedReturn=1', {urls: urls})
            .subscribe(data => {
                this.album();
            });
    }

    public album(pictureId = null) {
        this.loader.hide();
        CacheService.remove(CacheService.LOGGED_USER);
        let url = '/member/profile/album/';
        if (pictureId !== null) {
            url += pictureId;
        }
        this.router.navigate([url]);
    }

    public clickThumb(picture) {
        if (picture === undefined) {
            // show upload
            this.inputFile.nativeElement.click();
        } else {
            // redirect to the picture
            this.router.navigate(['/member/profile/album/' + picture.id]);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/album/upload.component.ts